import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';

import { HandleError, HttpErrorHandler } from './http-error-handler.service';
import { catchError } from 'rxjs/operators';

import { environment } from "src/environments/environment";

@Injectable()
export class MenuService {

    private apiServer = '';
    private handleError: HandleError;
    private menuSource = new Subject<string>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();
    
    constructor(
        private apiService: ApiService, httpErrorHandler: HttpErrorHandler
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('MenuService');
    }
    
    /*************************************************************************************
    **ENVELOPE
    **************************************************************************************/
    async getTareasRaicesData(): Promise<any> {
        return this.getTareasRaices().toPromise();
    }
    
    async getTareasData(): Promise<any> {
        return this.getTareas().toPromise();
    }

    /*************************************************************************************
    **REQUEST HTTP
    **************************************************************************************/
    getTareasRaices(){
        return this.apiService.get(this.apiServer + '/tareas/raices')
            .pipe(
                catchError(this.handleError('MenuService.getTareasRaices'))
            )
    }
    
    /**
    * Lista de tareas para los roles del usuario autenticado
    */
    getTareas(){
        return this.apiService.get(this.apiServer + '/tareas')
            .pipe(
                catchError(this.handleError('MenuService.getTareas'))
            )
    }
    
    onMenuStateChange(key: string) {
        this.menuSource.next(key);
    }

    reset() {
        this.resetSource.next();
    }
}
